import React, {
  useContext
} from "react";
import {
  Box,
  IconButton,
  Typography,
  CircularProgress,
  Chip,
} from "@mui/material";
import { Link } from "react-router-dom";
import { ChevronRight, Favorite, FavoriteBorder, ShoppingCart } from "@mui/icons-material";
import { CurrencyContext } from "../context/CurrencyContext";

const ProductCard = ({
  product,
  hoveredProductId,
  setHoveredProductId,
  handleAddToCart,
  handleAddToWishlist,
  addingToCartId,
  isInWishlist,
  isHovered,
}) => {

  const { selectedCurrency } = useContext(CurrencyContext);

  return (
    <Box
      key={product.id}
      sx={{
        position: "relative",
        display: "flex",
        flexDirection: "column",
        minWidth: "280px",
        padding: "20px",
        border: "1px solid #f5f5f5",
        borderRadius: 0,
        backgroundColor: "#f5f5f5",
        boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
        transition: "all 0.3s ease",
        cursor: "pointer",
        ":hover": {
          // boxShadow: "0 6px 18px rgba(0, 0, 0, 0.2)",
          border: "1px solid #9E6747",
        },
      }}
      onMouseEnter={() => setHoveredProductId(product.id)}
      onMouseLeave={() => setHoveredProductId(null)}
    >
      <Link to={`/product/${product.id}`}>
        <Box>
          {product?.soldOut && (
            <Chip
              label="Sold Out"
              color="error"
              sx={{ position: "absolute", top: 16, left: 16 }}
            />
          )}
          {product.discount && (
            <Chip
              // label={"-" + product.discount + "%"}
              label={product.discount + "% OFF"}
              color="primary"
              sx={{
                position: "absolute",
                top: 10,
                left: 10,
                backgroundColor: "#9E6747",
                color: "white",
                padding: "4px 8px",
                borderRadius: 0,
                // fontWeight: "bold",
                zIndex: 1,
                fontSize: "12px",
                fontFamily: "'Nunito Sans', sans-serif", // Font family
                opacity: hoveredProductId === product.id ? 0 : 1,
                visibility: hoveredProductId === product.id ? "hidden" : "visible",
                transition: "all 0.3s ease",
              }}
            />
          )}
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              position: "relative",
              width: "100%",
              maxWidth: "260px",
              borderRadius: 0,
              overflow: "hidden",
              height: "300px"
            }}
          >
            {/* Product Images */}
            <Box
              component="img"
              src={product.thumbnailz}
              alt={product.name}
              sx={{
                padding: "1rem",
                width: "100%",
                height: "200px",
                objectFit: "cover",
                transition: "opacity 0.5s ease",
                opacity: isHovered === product.id ? 0 : 1,
              }}
            />
            <Box
              component="img"
              src={product.images[0]}
              alt={product.description}
              sx={{
                position: "absolute",
                top: 0,
                left: 0,
                width: "100%",
                height: "200px",
                objectFit: "cover",
                transition: "opacity 0.5s ease",
                opacity: isHovered === product.id ? 1 : 0,
              }}
            />
          </Box>

          <Typography
            variant="caption"
            fontSize={"12px"}
            color={"#bebebe"}
            sx={{
              fontFamily: "'Playfair Display', serif", // Font family
              textAlign: "center", // Center-align text
              letterSpacing: "1px",
              marginBottom: "3px",
              marginTop: "12px",
            }}
          >
            {product.category_name}
          </Typography>
          <Typography
            variant="body1"
            fontWeight="600"
            sx={{
              marginBottom: "8px",
              fontFamily: "'Playfair Display', serif", // Font family
              fontSize: "24px",
              textAlign: "center", // Center-align text
            }}
          >
            {product.name
              .substr(0, 20)
              .split(" ")
              .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
              .join(" ")}
          </Typography>
          <Box
            display={"flex"}
            justifyContent="center"
            sx={{ marginTop: "auto" }}
          >
            <Typography
              variant="h6"
              fontSize={"12px"}
              // fontWeight="600"
              color={"#bebebe"}
              sx={{
                fontFamily: "'Nunito Sans', sans-serif", // Font family
                marginRight: "8px",
                textDecoration: "line-through",
                color: "#828382",
              }}
            >
              {selectedCurrency.code === "Rs"
                ? `${product.currency} ${product.sales_price}`
                : `${selectedCurrency.code} ${(product.sales_price / parseFloat(selectedCurrency.ratio)).toFixed(2)}`
              }
            </Typography>
            <Typography variant="h6"
              fontSize={"12px"}
              // fontWeight="600"
              sx={{
                fontFamily: "'Nunito Sans', sans-serif", // Font family
              }}
            >
              {selectedCurrency.code === "Rs"
                ? `${product.currency} ${(product.sales_price * (1 - product.discount / 100)).toFixed(2)}`
                : `${selectedCurrency.code} ${((product.sales_price * (1 - product.discount / 100)) / parseFloat(selectedCurrency.ratio)).toFixed(2)}`
              }
            </Typography>
            {/* <ChevronRight sx={{ color: "#2189ff", marginLeft: "8px" }} /> */}
          </Box>
        </Box>
      </Link>

      {/* Action Buttons */}
      <IconButton
        onClick={() => handleAddToCart(product)}
        sx={{
          position: "absolute",
          top: "70%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          backgroundColor: "#000",
          color: "#fff",
          borderRadius: 0,
          width: "60px",
          height: "40px",
          opacity: hoveredProductId === product.id ? 1 : 0,
          visibility: hoveredProductId === product.id ? "visible" : "hidden",
          transition: "all 0.3s ease",
          "&:hover": {
            backgroundColor: "#9E6747",
          },
          zIndex: 2,
        }}
      >
        {addingToCartId === product.id ? (
          <CircularProgress size={20} color="inherit" />
        ) : (
          <ShoppingCart />
        )}
      </IconButton>

      <IconButton
        onClick={() => handleAddToWishlist(product)}
        sx={{
          position: "absolute",
          // top: "38%",
          // left: "60%",
          top: "8%",  // Set to top
          right: 0,  // Set to right
          transform: "translate(-50%, -50%)",
          backgroundColor: isInWishlist[product.id] ? "#ff4646" : "#ffffff",
          color: "black",
          border: "1px solid black",
          borderRadius: "20px",
          width: "40px",
          height: "40px",
          opacity: hoveredProductId === product.id ? 1 : 0,
          visibility: hoveredProductId === product.id ? "visible" : "hidden",
          transition: "all 0.3s ease",
          "&:hover": {
            color: "#ffffff",
            backgroundColor: isInWishlist[product.id] ? "#ff6b6b" : "#000",
          },
          zIndex: 2,
        }}
      >
        {isInWishlist[product.id] ? <Favorite /> : <FavoriteBorder />}
      </IconButton>

    </Box>
  );
};

export default ProductCard;
